const siteConfig = {
  brandName: "ceowandmill",
  logo: {
    src: "/favicon.svg",
    alt: "ceowandmill home",
    text: "CEOWANDMILL",
  },
  description:
    "Elevated planning essentials designed to bring clarity, intention, and quiet beauty to every day.",
  operatingRegion: {
    country: "Mexico",
    countryCode: "MX",
  },
  contact: {
    email: "retail@ceowandmill.art",
    address: "Mexico",
    hours: "Monday–Friday",
  },
  currency: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
  },
  checkout: {
    orderPrefix: "CWM",
    demoPromoCode: "CLARITY10",
    demoDiscountRate: 0.1,
    lastOrderStorageKey: "storefrontLastOrder",
  },
  shipping: {
    standardRate: 9.99,
    processingTime: "1–2 business days",
    standardDelivery: "Varies by destination after dispatch",
    returnsWindowDays: 30,
    destinations: "Mexico and selected international destinations",
  },
};

export { siteConfig };
export default siteConfig;
